import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";

import addTask from "../../../../store/plan/actions/addTask";
import routing from "../../../../routing";
import Modal from "../../../../components/Modal";
import Form, { Cancel, Title } from "../../../../components/Form";
import { taskTypes } from "../../../../../common/parameters";
import Tabs from "../../../../components/Tabs";
import Icons from "../../../../icons";

import {
    NewTaskButton,
    Label,
    GroupWrapper,
    TabsWrapper,
} from "./styles";
import messages from "./messages";
import { IProps, IAddTaskButtonProps } from "./interfaces";

const rhythmTasks = ["rhytSorting", "rhytName", "rhytKnock", "rhytNotation", "barline"];
const melodyTasks = ["melodyTable", "solfaName", "piano", "singing", "handSign"];
const theoryTasks = ["tonesetStaff", "chords3", "intervals"];

const AddTaskButton = ({ taskType, addTask }: IAddTaskButtonProps) => {
    const [hover, setHover] = useState(false);
    const TaskIcon = Icons[taskType];
    const { formatMessage } = useIntl();
    return (
        <NewTaskButton
            onClick={() => {
                addTask(taskType);
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <TaskIcon active={hover} />
            <Label>{taskTypes(formatMessage)[taskType]}</Label>
        </NewTaskButton>
    );
}

const NewTaskModal = ({ close, plan }: IProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const [limit, setLimit] = useState<null | number>(null);
    const history = useHistory();

    const handleAddTask = (taskType: string) => {
        const nextTaskIndex = plan.tasks.length;
        dispatch(addTask({ planId: plan._id, index: nextTaskIndex, taskType }, (res) => {
            const { data } = res;
            if (data.limit) {
                setLimit(data.limit);
            } else {
                close();
                history.push(
                    "/" + routing.plan + "/" + plan._id + "/" + routing.tasks + "/" + (nextTaskIndex + 1)
                );
            }
        }));
    };
    return (
        <Modal close={close} width={300}>
            <Form>
                <Title>
                    <FormattedMessage {...messages.modalTitle} />
                </Title>
                {!limit && (
                    <TabsWrapper>
                        <Tabs expand>
                            {[
                                {
                                    title: formatMessage(messages.rhythm),
                                    content: (
                                        <GroupWrapper>
                                            {Object.keys(taskTypes(formatMessage))
                                                .filter(type => rhythmTasks.includes(type))
                                                .map((taskType, index) => (
                                                    <AddTaskButton
                                                        key={index}
                                                        taskType={taskType}
                                                        addTask={handleAddTask}
                                                    />
                                                ))}
                                        </GroupWrapper>
                                    ),
                                },
                                {
                                    title: formatMessage(messages.melody),
                                    content: (
                                        <GroupWrapper>
                                            {Object.keys(taskTypes(formatMessage))
                                                .filter(type => melodyTasks.includes(type))
                                                .map((taskType, index) => (
                                                    <AddTaskButton
                                                        key={index}
                                                        taskType={taskType}
                                                        addTask={handleAddTask}
                                                    />
                                                ))}
                                        </GroupWrapper>
                                    ),
                                },
                                {
                                    title: formatMessage(messages.theory),
                                    content: (
                                        <GroupWrapper>
                                            {Object.keys(taskTypes(formatMessage))
                                                .filter(type => theoryTasks.includes(type))
                                                .map((taskType, index) => (
                                                    <AddTaskButton
                                                        key={index}
                                                        taskType={taskType}
                                                        addTask={handleAddTask}
                                                    />
                                                ))}
                                        </GroupWrapper>
                                    ),
                                },
                                {
                                    title: formatMessage(messages.other),
                                    content: (
                                        <GroupWrapper>
                                            {Object.keys(taskTypes(formatMessage))
                                                .filter(
                                                    type =>
                                                        !melodyTasks.includes(type) &&
                                                        !rhythmTasks.includes(type) &&
                                                        !theoryTasks.includes(type)
                                                )
                                                .map((taskType, index) => (
                                                    <AddTaskButton
                                                        key={index}
                                                        taskType={taskType}
                                                        addTask={handleAddTask}
                                                    />
                                                ))}
                                        </GroupWrapper>
                                    ),
                                },
                            ]}
                        </Tabs>
                        <Cancel onClick={close}>
                            <FormattedMessage {...messages.cancel} />
                        </Cancel>
                    </TabsWrapper>
                )}
                {limit && (
                    <div>
                        <FormattedMessage {...messages.modalLimitReached} values={{ limit }} />
                        <Cancel onClick={close}>
                            <FormattedMessage {...messages.close} />
                        </Cancel>
                    </div>
                )}
            </Form>
        </Modal>
    )
};

export default NewTaskModal;
